export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/2cb37da391587709fd85749e116baa74.svg";